module.exports = __webpack_public_path__ + "static/media/Developmentbanner@2x.7dca50ef.png";